const convertArrayToObject = (array) => {
  const initialValue = {}
  return array.reduce((obj, item) => {
    return {
      ...obj,
      [item.key]: item.message,
    }
  }, initialValue)
}

export const graphQLErrorParser = (graphQLErrors) => {
  if (!graphQLErrors || graphQLErrors.length === 0) return null

  const formErrors = convertArrayToObject(
    graphQLErrors.filter((error) => !!error.key && error.message)
  )
  const generalErrors = graphQLErrors.map((error) => {
    if (error.key) return `${error.key} - ${error.message}`
    return `${error.message}`
  })
  const defaultError = generalErrors?.[0] || null
  return { defaultError, generalErrors, formErrors }
}
